import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';

import DetailsRow from './DetailsRow';

const CryptoPowerlistRow = ({ section, details, setDetails, isOperatorsSection }) => {
  const imgixUrl = 'https://tii.imgix.net/production/crypto-power-list/edited';
  const screenMd = 992;

  const handlePersonClick = (idx) => {
    setDetails(section[idx]);

    // track ahoy click event
    ahoy.start();
    ahoy.track('crypto-powerlist-profile-click', {
      person: section[idx].name,
      user_id: currentUser.id,
      email: currentUser.email,
      page: window.location.pathname,
    });
  };

  const handleClose = () => {
    setDetails({});
  };

  return (
    <div className="CryptoPowerlistRow">
      <div className="profile-row">
        {section.map((person, idx) => (
          <Fragment key={person.rank}>
            <div className="person-container mb3" onClick={() => handlePersonClick(idx)}>
              <div className={`rank ${person.rank >= 10 ? '--extend' : ''}`}>{person.rank}</div>
              <div
                className="portrait-image-container"
                style={{
                  WebkitMaskImage: `url(${imgixUrl}/${person.photo}?fmt=webp&w=250&h=250&fit=crop)`,
                  WebkitMaskSize: '250px auto',
                }}
              >
                <img
                  height={250}
                  width={250}
                  src={`${imgixUrl}/${person.photo}?fmt=webp&w=250&h=250&fit=crop`}
                />
                <div className="hidden-text">Read More</div>
              </div>
              <div className="person-name">{person.name}</div>
              <div className="person-firm mt1">{person.firm}</div>
            </div>
            {details?.name === person.name && window.innerWidth <= screenMd && (
              <DetailsRow
                details={details}
                handleClose={handleClose}
                isOperatorsSection={isOperatorsSection}
              />
            )}
          </Fragment>
        ))}
      </div>
      {!isEmpty(details) &&
        section.filter(({ name }) => name === details.name).length > 0 &&
        window.innerWidth > screenMd && (
          <DetailsRow
            details={details}
            handleClose={handleClose}
            isOperatorsSection={isOperatorsSection}
          />
        )}
    </div>
  );
};

export default CryptoPowerlistRow;
